import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { Tournament } from '../../../../../../models/tournament';
import { TournamentReportOptionsForm } from '../TournamentReportOptionsForm';
interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  tournament: Tournament;
}
export function TournamentPlayersReportForm(props: Props) {
  return (
    <TournamentReportOptionsForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_PLAYERS}
      description="View students involved in the selected tournament and the teams or events they have entered."
      options={[
        {
          field: 'isShowBlank',
          label: 'Show empty entries',
          hint: 'Include teams and events that do not yet have players.',
          initialValue: true
        }
      ]}
    />
  );
}
